import { render, staticRenderFns } from "./MainColumnInfo.vue?vue&type=template&id=c9c93732&scoped=true&"
import script from "./MainColumnInfo.vue?vue&type=script&lang=js&"
export * from "./MainColumnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c93732",
  null
  
)

export default component.exports